import CONSTANTS from "../Constants/Constants";

import $ from "jquery";

// Getting url query if any so as to set search object based on the query
// This will help with shareable links
// Query example: ?ngn=1&ag=agent_id&bl=booking_link_id&product=0&type=one-way&date=2024-12-05&dpt_airport=LGA&dst_airport=LHR&cabin=ECONOMY&adults=1&children=0&infants=0
const params = new URLSearchParams(window.location.search);

// Checking for existence of Agent Id as its required for Agent Client App
if(params.has("ag")){
  localStorage.setItem("agent", params.get('ag').trim());
}

// Checking for existence of Deal ID as its required for Agent Client App
//if(params.has("dlid")){
  //localStorage.setItem("deal_id", params.get('dlid').trim());
//}

// Checking for existence of Agent Id as its required for Agent Client App
if(params.has("cust")){
  localStorage.setItem("customer", params.get('cust').trim());
}

// Is it to load just agent booking engine (no search required) 
if(params.has("ngn")){
  // Just set the product type to lead initial search page
  localStorage.setItem(CONSTANTS.local_storage.product_type, CONSTANTS?.product_types?.flights);
  localStorage.setItem("booking_link", "");
  localStorage.setItem("package_id", "");
  const flight_search_data = {
    type: "one-way",
    itinerary: {
        departure: {
            airport: "",
            date: "",
            longitude: "",
            latitude: ""
        },
        arrival: {
            airport: "",
            date: "", // Not Arrival Date, but Date for Returning Flight if Round Trip
            longitude: "",
            latitude: ""
        },
        cabin: "ECONOMY",
        travelers: {
            adults: 1,
            children: 0,
            infants: 0
        }
    }
  }
  window.localStorage.setItem(CONSTANTS.local_storage.flight_search_object, JSON.stringify(flight_search_data));
  window.location = `${window.location.origin}/search`;
}

if( 
  params.has("booking_id") && // For checking booked item details only
  params.has("cust_eml")
){
  // Just set the product type to lead initial search page
  localStorage.setItem(CONSTANTS.local_storage.product_type, CONSTANTS?.product_types?.flights);
  localStorage.setItem("booking_link", "");
  localStorage.setItem("package_id", "");
  const flight_search_data = {
    type: "one-way",
    itinerary: {
        departure: {
            airport: "",
            date: "",
            longitude: "",
            latitude: ""
        },
        arrival: {
            airport: "",
            date: "", // Not Arrival Date, but Date for Returning Flight if Round Trip
            longitude: "",
            latitude: ""
        },
        cabin: "ECONOMY",
        travelers: {
            adults: 1,
            children: 0,
            infants: 0
        }
    }
  }
  window.localStorage.setItem(CONSTANTS.local_storage.flight_search_object, JSON.stringify(flight_search_data));
}

// Setting booking link id
// Checking for existence of Agent Id as its required for Agent Client App
if(params.has("bl")){
  localStorage.setItem("booking_link", params.get('bl').trim());
}

if(params.has("pkg")){
    localStorage.setItem("package_id", params.get('pkg').trim());
}

// Setting search object if url has a query or use object from Search Form
// Setting Flight Search Object
if(params.has('product') && parseInt(params.get('product')) === CONSTANTS?.product_types?.flights){
    localStorage.setItem(CONSTANTS.local_storage.product_type, CONSTANTS?.product_types?.flights);
  if(
    params.has('type') &&
    params.has('date') &&
    params.has('dpt_airport') &&
    params.has('dst_airport') &&
    params.has('cabin') &&
    params.has('adults')
  ){
    const flight_search_data = {
        type: "one-way",
        itinerary: {
            departure: {
                airport: "",
                date: "",
                longitude: "",
                latitude: ""
            },
            arrival: {
                airport: "",
                date: "", // Not Arrival Date, but Date for Returning Flight if Round Trip
                longitude: "",
                latitude: ""
            },
            cabin: "ECONOMY",
            travelers: {
                adults: 1,
                children: 0,
                infants: 0
            }
        }
    }

    //localStorage.setItem(CONSTANTS.local_storage.product_type, CONSTANTS?.product_types?.flights);

    if(params.has('type'))
      flight_search_data.type = params.get('type').trim();

    if(params.has('date')){
      if(flight_search_data.type==="round-trip"){
          flight_search_data.itinerary.departure.date = params.get('date').split(" - ")[0];
          flight_search_data.itinerary.arrival.date = params.get('date').split(" - ")[1];
      }else{
          flight_search_data.itinerary.departure.date = params.get('date');
      }
    }

    if(params.has('dpt_airport'))
      flight_search_data.itinerary.departure.airport = params.get('dpt_airport');

    if(params.has('dst_airport'))
      flight_search_data.itinerary.arrival.airport = params.get('dst_airport');

    if(params.has('cabin'))
      flight_search_data.itinerary.cabin = params.get('cabin');

    if(params.has('adults'))
      flight_search_data.itinerary.travelers.adults = parseInt(params.get('adults'));

    if(params.has('children'))
      flight_search_data.itinerary.travelers.children = parseInt(params.get('children'));

    if(params.has('infants'))
      flight_search_data.itinerary.travelers.infants = parseInt(params.get('infants'));

    /*/ Iterate over all parameters
    for (const [key, value] of params) {
      console.log(`${key}: ${value}`);
    }*/

    window.localStorage.setItem(CONSTANTS.local_storage.flight_search_object, JSON.stringify(flight_search_data));
  }

  // Required reset in order to resolve issue on production domain - needs reviewing
  let queryString = window.location.search
  let __page = window.location.pathname.substring(1);
  if(!__page){
    window.location = `${window.location.origin}/search${queryString}`;
  }
  
}

// Setting Hotel Search Object
if(params.has('product') && parseInt(params.get('product')) === CONSTANTS?.product_types?.stays){
  localStorage.setItem(CONSTANTS.local_storage.product_type, CONSTANTS?.product_types?.stays);
}

// Setting Rental Cars Search Object
if(params.has('product') && parseInt(params.get('product')) === CONSTANTS?.product_types?.rental_cars){
  localStorage.setItem(CONSTANTS.local_storage.product_type, CONSTANTS?.product_types?.rental_cars);
}

// Cleaning URL - Serving react with node-static folder on build issue of trailing slash (/) on url path
const url=window.location.href.replaceAll("/?", "?");
if(url.charAt(url.length-1)==="/"){
    window.history.pushState(null, "", url.substring(0,url.length-1));
}else{
  window.history.pushState(null, "", url);
}

export function show_login_page(){

    if(document.getElementById("site_main_header"))
        document.getElementById("site_main_header").style.display="block";
    if(document.getElementById("main_hero_section"))
        document.getElementById("main_hero_section").style.display="none";
    if($(window).width() > CONSTANTS.viewport_threshold)
        if(document.querySelector("header"))
            document.querySelector("header").style.backgroundColor="#000000";

    localStorage.removeItem("is_home_page");

    window.scrollTo(0, 0);
    change_nav_active_icon("mobile_login_menu_item", "desktop_login_menu_item");

    //if(document.getElementById("search_page"))
        //document.getElementById("search_page").style.display="none";
    if(document.getElementById("explore_page"))
        document.getElementById("explore_page").style.display="none";
    if(document.getElementById("home_page"))
        document.getElementById("home_page").style.display="none";
    if(document.getElementById("trips_page"))
        document.getElementById("trips_page").style.display="none";
    if(document.getElementById("deals_page"))
        document.getElementById("deals_page").style.display="none";
    if(document.getElementById("help_page"))
        document.getElementById("help_page").style.display="none";
    if(document.getElementById("login_page"))
        document.getElementById("login_page").style.display="block";

    global.history.pushState({}, "", CONSTANTS.site_pages.account);
    window.doAwaitingRefresh();
}

export function show_home_page(is_from_search=false){

    localStorage.setItem("is_home_page", "yes");

    if(document.getElementById("selected_ticket_pane"))
        document.getElementById("selected_ticket_pane").style.display="none";
    if($(window).width() > CONSTANTS.viewport_threshold)
        if(document.querySelector("header"))
            document.querySelector("header").style.background ="none";
    //document.getElementById("site_main_header").style.display="none";
    if(!is_from_search){
        // Important --- Code to review ----
        //if($(window).width() > CONSTANTS.viewport_threshold)
            //if(document.querySelector("header"))
                //document.querySelector("header").style.backgroundColor="#000000";
        //if(document.getElementById("main_hero_section"))
            //document.getElementById("main_hero_section").style.display="block";
        //localStorage.removeItem("is_home_page");
    }else{
        if(document.getElementById("main_hero_section"))
            document.getElementById("main_hero_section").style.display="none";
    }

    window.scrollTo(0, 0);
    change_nav_active_icon("mobile_search_menu_item", "desktop_search_menu_item");

    //if(document.getElementById("search_page"))
        //document.getElementById("search_page").style.display="none";
    if(document.getElementById("explore_page"))
        document.getElementById("explore_page").style.display="none";
    if(document.getElementById("login_page"))
        document.getElementById("login_page").style.display="none";
    if(document.getElementById("trips_page"))
        document.getElementById("trips_page").style.display="none";
    if(document.getElementById("deals_page"))
        document.getElementById("deals_page").style.display="none";
    if(document.getElementById("help_page"))
        document.getElementById("help_page").style.display="none";
    if(document.getElementById("home_page"))
        document.getElementById("home_page").style.display="block";
    global.history.pushState({}, "", CONSTANTS.site_pages.landing);
    window.doAwaitingRefresh();
}

export function show_search_page(){

    let queryString = window.location.search
    localStorage.removeItem("is_home_page");

    if(document.getElementById("site_main_header"))
        document.getElementById("site_main_header").style.display="block";
    if(document.getElementById("main_hero_section"))
        document.getElementById("main_hero_section").style.display="none";
    if($(window).width() > CONSTANTS.viewport_threshold)
        if(document.querySelector("header"))
            document.querySelector("header").style.backgroundColor="#000000";

    window.scrollTo(0, 0);
    change_nav_active_icon("mobile_search_menu_item", "desktop_search_menu_item");

    //if(document.getElementById("home_page"))
        //document.getElementById("home_page").style.display="none";
    if(document.getElementById("explore_page"))
        document.getElementById("explore_page").style.display="none";
    if(document.getElementById("login_page"))
        document.getElementById("login_page").style.display="none";
    if(document.getElementById("trips_page"))
        document.getElementById("trips_page").style.display="none";
    if(document.getElementById("deals_page"))
        document.getElementById("deals_page").style.display="none";
    if(document.getElementById("help_page"))
        document.getElementById("help_page").style.display="none";
    //if(document.getElementById("search_page"))
        //document.getElementById("search_page").style.display="block";
    global.history.pushState({}, "", (CONSTANTS.site_pages.search+queryString));
    window.doAwaitingRefresh();
}

export function show_trips_page(){

    localStorage.removeItem("is_home_page");

    if(document.getElementById("site_main_header"))
        document.getElementById("site_main_header").style.display="block";
    if(document.getElementById("main_hero_section"))
        document.getElementById("main_hero_section").style.display="none";
    if($(window).width() > CONSTANTS.viewport_threshold)
        document.querySelector("header").style.backgroundColor="#000000";

    window.scrollTo(0, 0);
    change_nav_active_icon("mobile_trips_menu_item", "desktop_trips_menu_item");

    //if(document.getElementById("search_page"))
        //document.getElementById("search_page").style.display="none";
    if(document.getElementById("explore_page"))
        document.getElementById("explore_page").style.display="none";
    if(document.getElementById("login_page"))
        document.getElementById("login_page").style.display="none";
    if(document.getElementById("home_page"))
        document.getElementById("home_page").style.display="none";
    if(document.getElementById("deals_page"))
        document.getElementById("deals_page").style.display="none";
    if(document.getElementById("trips_page"))
        document.getElementById("trips_page").style.display="block";

    global.history.pushState({}, "", CONSTANTS.site_pages.trips);
    window.doAwaitingRefresh();
}

export function show_deals_page(){

    let queryString = window.location.search;
    localStorage.removeItem("is_home_page");

    if(document.getElementById("site_main_header"))
        document.getElementById("site_main_header").style.display="block";
    if(document.getElementById("main_hero_section"))
        document.getElementById("main_hero_section").style.display="none";
    if($(window).width() > CONSTANTS.viewport_threshold)
        if(document.querySelector("header"))
            document.querySelector("header").style.backgroundColor="#000000";

    window.scrollTo(0, 0);
    //change_nav_active_icon("mobile_trips_menu_item", "desktop_trips_menu_item");

    //if(document.getElementById("search_page"))
        //document.getElementById("search_page").style.display="none";
    if(document.getElementById("explore_page"))
        document.getElementById("explore_page").style.display="none";
    if(document.getElementById("login_page"))
        document.getElementById("login_page").style.display="none";
    if(document.getElementById("home_page"))
        document.getElementById("home_page").style.display="none";
    if(document.getElementById("deals_page"))
        document.getElementById("deals_page").style.display="block";
    if(document.getElementById("help_page"))
        document.getElementById("help_page").style.display="none";
    if(document.getElementById("trips_page"))
        document.getElementById("trips_page").style.display="none";

    global.history.pushState({}, "", (CONSTANTS.site_pages.deals+queryString));
    window.doAwaitingRefresh();

    // Initializing Deals Page
    // window.__InitDealsPage();
}

export function show_explore_page(){

    localStorage.removeItem("is_home_page");

    if(document.getElementById("site_main_header"))
        document.getElementById("site_main_header").style.display="block";
    if(document.getElementById("main_hero_section"))
        document.getElementById("main_hero_section").style.display="none";
    if($(window).width() > CONSTANTS.viewport_threshold)
        if(document.querySelector("header"))
            document.querySelector("header").style.backgroundColor="#000000";

    window.scrollTo(0, 0);
    change_nav_active_icon("mobile_search_menu_item", "desktop_explore_menu_item");

    //if(document.getElementById("search_page"))
        //document.getElementById("search_page").style.display="none";
    if(document.getElementById("trips_page"))
        document.getElementById("trips_page").style.display="none";
    if(document.getElementById("deals_page"))
        document.getElementById("deals_page").style.display="none";
    if(document.getElementById("help_page"))
        document.getElementById("help_page").style.display="none";
    if(document.getElementById("login_page"))
        document.getElementById("login_page").style.display="none";
    if(document.getElementById("home_page"))
        document.getElementById("home_page").style.display="none";
    if(document.getElementById("explore_page"))
        document.getElementById("explore_page").style.display="block";

    global.history.pushState({}, "", CONSTANTS.site_pages.explore);
    window.doAwaitingRefresh();
}

export function show_help_page(){

    let queryString = window.location.search;
    localStorage.removeItem("is_home_page");

    //toggle_main_page_search_filters()

    /*if(document.getElementById("site_main_header"))
        document.getElementById("site_main_header").style.display="block";
    if(document.getElementById("main_hero_section"))
        document.getElementById("main_hero_section").style.display="none";
    if($(window).width() > CONSTANTS.viewport_threshold)
        document.querySelector("header").style.backgroundColor="#000000";*/

    window.scrollTo(0, 0);
    //change_nav_active_icon("mobile_search_menu_item", "desktop_explore_menu_item");

    if(document.getElementById("search_page"))
        document.getElementById("search_page").style.display="none";
    if(document.getElementById("trips_page"))
        document.getElementById("trips_page").style.display="none";
    if(document.getElementById("deals_page"))
        document.getElementById("deals_page").style.display="none";
    if(document.getElementById("help_page"))
        document.getElementById("help_page").style.display="block";
    if(document.getElementById("login_page"))
        document.getElementById("login_page").style.display="none";
    if(document.getElementById("home_page"))
        document.getElementById("home_page").style.display="none";
    if(document.getElementById("explore_page"))
        document.getElementById("explore_page").style.display="none";

    global.history.pushState({}, "", (CONSTANTS.site_pages.support+queryString));
    window.doAwaitingRefresh();
}

export function show_full_search_form(){

    /*if(document.getElementById("landing_page_search_filters_container").style.display==="none"){
        //do nothing
    }else{
        toggle_main_page_search_filters();
    }*/

    window.scrollTo(0, 0);

    document.getElementById("site_main_header").style.display="block";
    document.getElementById("main_hero_section").style.display="block";
    if($(window).width() > CONSTANTS.viewport_threshold)
        document.querySelector("header").style.backgroundColor="#000000";
    localStorage.removeItem("is_home_page");
}

export function change_nav_active_icon(mobile_id, desktop_id){
    //for mobile
    Array.from(document.getElementsByClassName("header_mobile_menus_item")).forEach(each => {
        each.classList.remove("active");
    });
    //for desktop
    Array.from(document.getElementsByClassName("each-header-menu-item")).forEach(each => {
        each.classList.remove("active");
    });

    //setting current active item
    //document.getElementById(mobile_id).classList.add("active");
    //document.getElementById(desktop_id).classList.add("active");
}

window.setAwaitDoRefresh = () =>{
    localStorage.setItem("DO_REFRESH", "1");
}

window.doAwaitingRefresh = () => {
    if(localStorage.getItem("DO_REFRESH")){
        localStorage.removeItem("DO_REFRESH");
        window.location.reload();
    }
}

window.addEventListener('popstate', function(e) {
    UseCurrentPage();
});
const UseCurrentPage = () => {
    let page = window.location.pathname.substring(1);
    if(CONSTANTS.site_pages.account===page){
      show_login_page()
    }
    if(CONSTANTS.site_pages.support===page){
        show_help_page()
    }
    if(CONSTANTS.site_pages.deals===page){
        show_deals_page()
    }
    if(CONSTANTS.site_pages.explore===page){
        show_explore_page()
    }
    if(CONSTANTS.site_pages.trips===page){
        show_trips_page()
    }
    if(CONSTANTS.site_pages.landing===page){
        show_home_page();
        window.__show_home_page__();
    }
    if(CONSTANTS.site_pages.search===page){
        show_search_page();
        window.__show_search_page__();
    }
}

export default UseCurrentPage;
